import {
  QueryClient,
  QueryClientProvider,
  useQuery as dcWebUseQuery,
  useMutation as dcWebUseMutation,
  useQueryClient as dcWebUseQueryClient,
  useInfiniteQuery as dcWebUseInfiniteQuery,
} from 'react-query'

const HOT_DATA_STALE_TIME = 3000
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: HOT_DATA_STALE_TIME,
    },
  },
})

export const useQuery = dcWebUseQuery
export const useMutation = dcWebUseMutation
export const useQueryClient = dcWebUseQueryClient
export const useInfiniteQuery = dcWebUseInfiniteQuery

export const ReactQueryProvider = ({
  children,
  client,
}: {
  children: React.ReactNode
  client?: QueryClient
}) => {
  return (
    <QueryClientProvider client={client ?? queryClient}>
      {children}
    </QueryClientProvider>
  )
}
